<script setup lang="ts">
  const props = defineProps<{
    id: string
    carrierName: string
    externalAppUrl?: string | null | undefined
    planYear: number
    onHpApply: Function
  }>()

  const { getComponentContent, hydratePlaceholders } = Cms.use()
  const profile = ProfileStore.use()

  const { content } = await getComponentContent('EnrollmentLocationOptionModal')

  const { track } = Analytics.use()

  const carrierUrl = computed(() =>
    hydratePlaceholders(props.externalAppUrl!, {
      planYear: props.planYear,
      zipCode: profile.location!.zipCode!,
      countyFips: profile.location!.fipsCountyCode!
    })
  )

  const { hide } = DialogController.use()

  const onSelectHp = () => {
    track('EnrollmentLocationOptionSelected', {
      option: 'healthpilot'
    })

    hide(props.id)
    props.onHpApply()
  }

  const onSelectCarrier = () => {
    track('EnrollmentLocationOptionSelected', {
      option: props.carrierName
    })

    hide(props.id)
    window.open(carrierUrl.value, '_blank')
  }
</script>

<template>
  <HpModal :title="content.ext.header" :id hide-footer size="xl">
    <p class="mb-4 w-full text-center" v-html="content.ext.subheader" />
    <BaseFormRadioGroup button-flex class="enrollment-loc-options">
      <BaseFormRadio value="hp" @click="onSelectHp" icon="logo-only-color">
        <template #icon>
          <div class="flex w-full justify-center">
            <HpIcon name="healthpilot-icon" class="h-14 w-14" />
          </div>
        </template>
        {{ content.ext.hp_main_text }}
        <div class="text-sm font-normal leading-tight">{{ content.ext.hp_sub_text }}</div>
      </BaseFormRadio>
      <BaseFormRadio value="carrier" @click="onSelectCarrier" icon="external-link">
        {{
          hydratePlaceholders(content.ext.carrier_main_text, {
            carrierName: props.carrierName
          })
        }}
        <div class="text-sm font-normal leading-tight">
          {{
            hydratePlaceholders(content.ext.carrier_sub_text, {
              carrierName: props.carrierName
            })
          }}
        </div>
      </BaseFormRadio>
    </BaseFormRadioGroup>
  </HpModal>
</template>

<style scoped>
  .enrollment-loc-options {
    :deep(label.form-check) {
      @apply h-[13rem];
    }
  }
</style>
